/**
 * Created by alvinoktavianus on 6/27/17.
 */

import { GET_FEATURE_PRICE } from './constants'

export function getFeaturePrice (data, params) {
  return axios
    .post(GET_FEATURE_PRICE, data, {params, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./app/api/feature/getFeaturePrice.js